import * as React from "react";
import { useEffect, useRef, useState } from "react";
import styled, { css, createGlobalStyle } from "styled-components";
import { useTranslation } from "react-i18next";
import { Icon } from "components/common";
import { Button, Panel } from "components/bootstrap";
const ErrorOutputStyle = createGlobalStyle`
  /* NOTE: This is to remove Bootstrap styles from the anchor element I can't override in Panel.Header */
  form {
    .panel.panel-danger {
      .panel-heading > a {
        font-size: 14px;
        text-decoration: none;
        color: #AD0707;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
`;
const ErrorOutput = styled.span`
  display: block;
`;
const ErrorToggleInfo = styled.button(
  ({ theme }) => css`
    border: 0;
    background: none;
    color: ${theme.colors.gray[10]};
    font-size: ${theme.fonts.size.small};
    text-transform: uppercase;
    margin: 12px 0 0;
    padding: 0;
    &:hover {
      text-decoration: underline;
    }
  `
);
export const ErrorMessage = ({ full_message, nice_message = null }) => {
  const { t } = useTranslation("enterprise_integrations");
  const [expanded, toggleExpanded] = useState(false);
  const Header = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ErrorOutputStyle, null), /* @__PURE__ */ React.createElement(ErrorOutput, null, nice_message || full_message), nice_message && /* @__PURE__ */ React.createElement(ErrorToggleInfo, { onClick: () => toggleExpanded(!expanded) }, t("common.form_wrap.more_info"), " ", /* @__PURE__ */ React.createElement(Icon, { name: expanded ? "keyboard_arrow_down" : "chevron_right" })));
  if (!nice_message) {
    return /* @__PURE__ */ React.createElement(Panel, { header: Header, bsStyle: "danger" });
  }
  return /* @__PURE__ */ React.createElement(Panel, { header: Header, bsStyle: "danger", collapsible: true, expanded }, /* @__PURE__ */ React.createElement("strong", null, t("common.form_wrap.additional_information"), " "), full_message);
};
const FormWrap = ({
  buttonContent,
  children = void 0,
  className = void 0,
  disabled = false,
  description = null,
  error = null,
  loading = false,
  onSubmit,
  title = null
}) => {
  const { t } = useTranslation("enterprise_integrations");
  const formRef = useRef(null);
  const [disabledButton, setDisabledButton] = useState(disabled);
  const prevent = (event) => {
    event.preventDefault();
    return false;
  };
  useEffect(() => {
    setDisabledButton(loading || disabled);
  }, [loading, disabled]);
  return /* @__PURE__ */ React.createElement("form", { onSubmit: prevent, autoComplete: "off", noValidate: true, className, ref: formRef }, title && (typeof title === "string" ? /* @__PURE__ */ React.createElement("h2", null, title) : title), description && (typeof description === "string" ? /* @__PURE__ */ React.createElement("p", null, description) : description), error && error.full_message && /* @__PURE__ */ React.createElement(ErrorMessage, { full_message: error.full_message, nice_message: error.nice_message }), children, /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: disabledButton ? null : onSubmit, bsStyle: "primary", disabled: disabledButton }, loading ? t("common.buttons.loading") : buttonContent != null ? buttonContent : t("common.buttons.submit")));
};
export default FormWrap;
